import React, { lazy, Suspense, useEffect, useState } from "react";

import Navbar from "./components/navbar";

import Herosection from "./components/herosection";

import Footer from "./components/footer";

import {
  BrowserRouter as Router,
  Route,
  Routes,
} from "react-router-dom";
import "./App.css";
import ScrollToTop from "./components/ScrollToTop";

import LoadingSpinner from "./components/LoadingSpinner";
import Products from "./components/products";
import SEO from "./components/SEO";

const NavbarES = lazy(() => import("./components/navbar_ES"));
const HerosectionES = lazy(() => import("./components/herosection_ES"));
const FooterES = lazy(() => import("./components/footer_ES"));
const ProductsES = lazy(() => import("./components/products_ES"));
const Contact = lazy(() => import("./components/contact"));
const ContactES = lazy(() => import("./components/contact_ES"));
const AboutUs = lazy(() => import("./components/about_us"));
const AboutUsES = lazy(() => import("./components/about_us_ES"));
const PageNotFound = lazy(() => import("./components/PageNotFound"));

const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Mompó Mass Wines",
  telephone: "+34-963-93-57-50",
  email: "paratono@gmail.com",
  url: "https://www.mompomasswines.com/",
  logo: "https://www.mompomasswines.com/mompo-logo.svg",
  address: {
    "@type": "PostalAddress",
    streetAddress: "Jaime Roig 19 1A",
    addressLocality: "Valencia",
    addressRegion: "Valencia",
    postalCode: "46010",
    addressCountry: "ES",
  },
};

function App() {
  const language = window.location.pathname.split("/")[1];

  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 600);

    return () => {
      clearTimeout(timer);
    };
  }, []);
  return (
    <>
      <Router>
        <ScrollToTop />
        <Suspense fallback={<LoadingSpinner />}>
          {language === "es" ? <NavbarES /> : <Navbar />}
          <Routes>
            <Route path="/" element={<Home />} />
            {/*           English       */}
            <Route path="/en/Contact" element={<Contact />} />
            <Route path="/en/About" element={<AboutUs />} />
            <Route path="/en/" element={<Home />} />
            {/*           español       */}
            <Route path="/es/Contact" element={<ContactES />} />
            <Route path="/es/About" element={<AboutUsES />} />
            <Route path="/es/" element={<HomeES />} />

            <Route path="/404-page-not-found" element={<PageNotFound />} />
            <Route path="*" element={<PageNotFound />} />
          </Routes>
        </Suspense>
        {loading ? <LoadingSpinner /> : ""}
      </Router>
    </>
  );
}

function Home() {
  return (
    <>
      <SEO
        title="Holy Wine and Sacramental Wine | Mompó Mass Wines"
        description="Discover Mompó holy and sacramental wines, crafted for church ceremonies and backed by more than 170 years of winemaking tradition."
        path="/en/"
        alternatePath="/es/"
        language="en"
        schema={organizationSchema}
      />
      <Herosection />
      <div id="BestWine">
        <Products />
      </div>
      <Footer />
    </>
  );
}
function HomeES() {
  return (
    <>
      <SEO
        title="Vino de Misa y Vino Sacramental | Mompó"
        description="Descubra los vinos de misa y sacramentales Mompó, elaborados para celebraciones religiosas con más de 170 años de tradición vinícola."
        path="/es/"
        alternatePath="/en/"
        language="es"
        schema={organizationSchema}
      />
      <HerosectionES />
      <div id="BestWine">
        <ProductsES />
      </div>
      <FooterES />
    </>
  );
}

export default App;
